import { ChangeDetectionStrategy, Component, ElementRef, HostListener, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RemindersListItemComponent } from '../reminders-list-item/reminders-list-item.component';
import { ReminderStore } from '../../store/reminders-store';
import { RemindersListHeaderComponent } from '../reminders-list-header/reminders-list-header.component';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { NoResultComponent } from "../../../../shared/components/no-result/no-result.component";
import { ManipulationsToolbarComponent } from 'src/app/shared/components/manipulations-toolbar/manipulations-toolbar.component';
import { ManipulationsToolbarStore } from 'src/app/store/manipulations-toolbar-store';

@Component({
    selector: 'que-reminders-list',
    templateUrl: './reminders-list.component.html',
    styleUrls: ['./reminders-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, RemindersListItemComponent, RemindersListHeaderComponent,
        TranslateDirective, TranslatePipe, NoResultComponent, ManipulationsToolbarComponent]
})
export class RemindersListComponent {
  #reminderStore = inject(ReminderStore);
  #manipulationsToolbarStore = inject(ManipulationsToolbarStore);
  reminders$ =toSignal(this.#reminderStore.reminders$.pipe(map(x => x.result))) ;
  remindersExtra$ = toSignal(this.#reminderStore.remindersExtra$);
  isResult$ = toSignal(this.#reminderStore.totals$.pipe(map(x => x != undefined && x > 0)));
  isEmpty$ = toSignal(this.#reminderStore.isEmpty$);
  loadingExtra$ = toSignal(this.#reminderStore.loadingExtra$);
  loading$ = toSignal(this.#reminderStore.loading$);
  isFilterListOpen$ = toSignal(this.#manipulationsToolbarStore.isFilterListOpen$);
  
  constructor(private el: ElementRef) {
  }

  @HostListener('document:mousewheel', ['$event'])
  onWindowScroll(event: any) {
    const scrollContainer = this.el.nativeElement.querySelector('.scroll');
    if (scrollContainer) {
      const scrollBottom = scrollContainer.scrollHeight - scrollContainer.clientHeight;
      if (scrollContainer.scrollTop >= scrollBottom - 1) {
        var is10InExtra = this.remindersExtra$()?.result.length == 10;
        if (this.remindersExtra$()?.result && this.remindersExtra$()!.result.length > 0) {
          this.getRemindersExtra();
        }
        if (this.remindersExtra$() && is10InExtra && !this.loadingExtra$())
          this.loadMore();
      }
    }
  }

  getRemindersExtra() {
    this.#reminderStore.updateRemindersWithExtra();
  }

  loadMore() {
    this.#reminderStore.loadRemindersForExtra();
  }

}
